// NOTE: NSAI-6105 — account-recovery links carry a single-use credential in the
// query string (`/auth/reset-password?token=`, `/auth/accept-invite?token=`).
// Redacting it out of analytics stops it reaching PostHog, but the value is
// still sitting in the address bar, and from there it reaches browser history
// (synced across devices), the `Referer` header on same-origin requests, and
// anything on screen during a share. Dropping it from the URL as soon as the
// page has read it is the only thing that closes those.
//
// `history.replaceState` rather than react-router's `setSearchParams`: this
// must REPLACE the current entry, never push a new one, and it must not make
// react-router re-render the page with a now-missing token. Same call the
// Trello OAuth callback already makes for the same reason.
export const stripUrlCredential = ({
  parameter,
}: {
  parameter: string;
}): void => {
  const params = new URLSearchParams(globalThis.location.search);
  if (!params.has(parameter)) return;

  params.delete(parameter);

  // NOTE: Other parameters are preserved — only the credential is removed, so
  // an unrelated flag on the same link keeps working.
  const query = params.toString();
  const nextUrl = `${globalThis.location.pathname}${query ? `?${query}` : ""}`;

  // NOTE: The CURRENT state is carried over rather than replaced with `null`.
  // `BrowserRouter` keeps `{ usr, key, idx }` there, and blanking it costs the
  // router its index (so a popstate back to this entry reports a `null` delta
  // and `useBlocker` misbehaves) and its `location.key`, which falls back to
  // "default" and collides scroll-restoration keys. `TrelloCallback` passes
  // `null` for the same call, but it navigates away immediately — here the user
  // stays on the page, so the state has to survive.
  globalThis.history.replaceState(globalThis.history.state, "", nextUrl);
};
